export const addonAchievements: Record<number, boolean> = Object.fromEntries(
    [
        14765, // Ramparts Racer
        14766, // Parasoling
    ].map((id) => [id, true])
);

export const forceAddonCriteria: Record<number, number> = {
    9450: 9452, // The Trap Game -> Trap Superstar
    9565: 9452, // Master Trapper -> Trap Superstar
    9451: 9452, // Trapper's Delight -> Trap Superstar
    9452: 9452, // Trap Superstar -> Trap Superstar
};

export const forceSupersededBy: Record<number, number> = {
    9: 14782, // Level 40 -> Level 50
    5324: 5325, // In Service of the Horde -> Veteran of the Horde
    5327: 5328, // In Service of the Alliance -> Veteran of the Alliance
    13701: 13702, // Battlefield Brawler -> Battlefield Tactician
    13702: 13703, // Battlefield Tactician -> Battlefield Master
    63434: 63435, // Buddy System VII: Valeera -> Buddy System VIII: Valeera
};

export const forceShowCriteriaTree: Set<number> = new Set<number>([
    80091, // Waveblade Ankoan
]);

export const forceGarrisonTalent: Record<number, [number, number]> = {
    91802: [1863, 2], // Elite Slayer Rank 2
    91803: [1783, 3], // Blessing Rank 3
    91804: [1787, 2], // Emp. Swiftness Rank 2
    91805: [1794, 1], // Efficent Looter
    91806: [1784, 2], // Freed from torment Rank 2
    91807: [1785, 3], // Emp Perservance Rank 3
    91808: [1792, 3], // Discovered Cache Rank 3
    91809: [1793, 5], // Undeterred Rank 5
    91810: [1788, 1], // Adamant Vaults
    91811: [1786, 5], // Inexplicable Power Rank 5
    91812: [1789, 1], // Enduring Souls
    91813: [1790, 2], // Good Reflexes Rank 2
    91814: [1791, 3], // Death Denied Rank 3
    91815: [1861, 5], // Unfllinching Rank 5
    91816: [1865, 3], // Anima Plunder Rank 3
    91817: [1864, 3], // Meddle with Fate 3
    91818: [1878, 1], // Empowered Mastery
};

export const forceSupersedes: Record<number, number> = Object.fromEntries(
    Object.entries(forceSupersededBy).map(([dest, src]) => [src, parseInt(dest)])
);

export const honorAchievements: Record<number, boolean> = Object.fromEntries(
    [
        12893, // Honor Level 5
        12894, // Honor Level 10
        12895, // Honor Level 15
        12900, // Honor Level 20
        12901, // Honor Level 25
        12902, // Honor Level 30
        12903, // Honor Level 40
        12904, // Honor Level 50
        12905, // Honor Level 60
        12906, // Honor Level 70
        12907, // Honor Level 80
        12908, // Honor Level 90
        12909, // Honor Level 100
        12910, // Honor Level 125
        12911, // Honor Level 150
        12912, // Honor Level 175
        12913, // Honor Level 200
        12914, // Honor Level 250
        12915, // Honor Level 300
        12916, // Honor Level 400
        12917, // Honor Level 500
    ].map((id) => [id, true])
);

type ExtraAchievementCategory = {
    slug: string;
    achievementIds?: number[];
    children: {
        // 1 = target category, 2 = parent category, 3 = custom
        nameType: number;
        targetSlug: string;

        achievementIds?: (number | number[])[];
        onlyAchievementIds?: boolean;
        overrideName?: string;
        overrideSlug?: string;
    }[];
};
export const extraCategories: ExtraAchievementCategory[] = [
    {
        slug: 'classic',
        children: [
            {
                targetSlug: 'exploration/eastern-kingdoms',
                nameType: 3,
                overrideName: 'Exploration > Eastern Kingdoms',
                overrideSlug: 'exploration-eastern-kingdoms',
            },
            {
                targetSlug: 'exploration/kalimdor',
                nameType: 3,
                overrideName: 'Exploration > Kalimdor',
                overrideSlug: 'exploration-kalimdor',
            },
            {
                targetSlug: 'quests/eastern-kingdoms',
                nameType: 3,
                overrideName: 'Quests > Eastern Kingdoms',
                overrideSlug: 'quests-eastern-kingdoms',
            },
            {
                targetSlug: 'quests/kalimdor',
                nameType: 3,
                overrideName: 'Quests > Kalimdor',
                overrideSlug: 'quests-kalimdor',
            },
            { targetSlug: 'reputation/classic', nameType: 1 },
            null,
            {
                targetSlug: 'dungeons-raids/classic',
                nameType: 3,
                overrideName: 'Dungeons & Raids',
                overrideSlug: 'dungeons-raids',
            },
        ],
    },
    {
        slug: 'the-burning-crusade',
        children: [
            { targetSlug: 'exploration/outland', nameType: 1 },
            { targetSlug: 'quests/outland', nameType: 1 },
            { targetSlug: 'reputation/the-burning-crusade', nameType: 1 },
            null,
            {
                targetSlug: 'dungeons-raids/the-burning-crusade',
                nameType: 3,
                overrideName: 'Dungeons & Raids',
                overrideSlug: 'dungeons-raids',
            },
        ],
    },
    {
        slug: 'wrath-of-the-lich-king',
        children: [
            { targetSlug: 'exploration/northrend', nameType: 1 },
            { targetSlug: 'quests/northrend', nameType: 1 },
            { targetSlug: 'reputation/wrath-of-the-lich-king', nameType: 1 },
            null,
            {
                targetSlug: 'dungeons-raids/lich-king-dungeon',
                nameType: 3,
                overrideName: 'Dungeons',
                overrideSlug: 'dungeons',
            },
            {
                targetSlug: 'dungeons-raids/lich-king-raid',
                nameType: 3,
                overrideName: 'Raids',
                overrideSlug: 'raids',
            },
            null,
            { targetSlug: 'expansion-features/argent-tournament', nameType: 2 },
        ],
    },
    {
        slug: 'cataclysm',
        children: [
            { targetSlug: 'exploration/cataclysm', nameType: 1 },
            { targetSlug: 'quests/cataclysm', nameType: 1 },
            { targetSlug: 'reputation/cataclysm', nameType: 1 },
            null,
            {
                targetSlug: 'dungeons-raids/cataclysm-dungeon',
                nameType: 3,
                overrideName: 'Dungeons',
                overrideSlug: 'dungeons',
            },
            {
                targetSlug: 'dungeons-raids/cataclysm-raid',
                nameType: 3,
                overrideName: 'Raids',
                overrideSlug: 'raids',
            },
            null,
            { targetSlug: 'expansion-features/tol-barad', nameType: 2 },
        ],
    },
    {
        slug: 'pandaria',
        children: [
            { targetSlug: 'exploration/pandaria', nameType: 1 },
            { targetSlug: 'quests/pandaria', nameType: 1 },
            { targetSlug: 'reputation/pandaria', nameType: 1 },
            null,
            {
                targetSlug: 'dungeons-raids/pandaria-dungeon',
                nameType: 3,
                overrideName: 'Dungeons',
                overrideSlug: 'dungeons',
            },
            {
                targetSlug: 'dungeons-raids/pandaria-raid',
                nameType: 3,
                overrideName: 'Raids',
                overrideSlug: 'raids',
            },
            null,
            { targetSlug: 'expansion-features/proving-grounds', nameType: 2 },
            {
                targetSlug: 'expansion-features/pandaria-scenarios',
                nameType: 3,
                overrideName: 'Scenarios',
                overrideSlug: 'scenarios',
            },
        ],
    },
    {
        slug: 'draenor',
        children: [
            { targetSlug: 'exploration/draenor', nameType: 1 },
            { targetSlug: 'quests/draenor', nameType: 1 },
            { targetSlug: 'reputation/draenor', nameType: 1 },
            null,
            {
                targetSlug: 'dungeons-raids/draenor-dungeon',
                nameType: 3,
                overrideName: 'Dungeons',
                overrideSlug: 'dungeons',
            },
            {
                targetSlug: 'dungeons-raids/draenor-raid',
                nameType: 3,
                overrideName: 'Raids',
                overrideSlug: 'raids',
            },
            null,
            {
                targetSlug: 'expansion-features/draenor-garrison',
                nameType: 3,
                overrideName: 'Garrison',
                overrideSlug: 'garrison',
            },
        ],
    },
    {
        slug: 'legion',
        children: [
            { targetSlug: 'exploration/legion', nameType: 1 },
            { targetSlug: 'quests/legion', nameType: 1 },
            { targetSlug: 'reputation/legion', nameType: 1 },
            null,
            {
                targetSlug: 'dungeons-raids/legion-dungeon',
                nameType: 3,
                overrideName: 'Dungeons',
                overrideSlug: 'dungeons',
            },
            {
                targetSlug: 'dungeons-raids/legion-raid',
                nameType: 3,
                overrideName: 'Raids',
                overrideSlug: 'raids',
            },
            null,
            {
                targetSlug: 'expansion-features/legion-class-hall',
                nameType: 3,
                overrideName: 'Class Hall',
                overrideSlug: 'class-hall',
            },
        ],
    },
    {
        slug: 'battle-for-azeroth',
        children: [
            { targetSlug: 'exploration/battle-for-azeroth', nameType: 1 },
            { targetSlug: 'quests/battle-for-azeroth', nameType: 1 },
            { targetSlug: 'reputation/battle-for-azeroth', nameType: 1 },
            null,
            {
                targetSlug: 'dungeons-raids/battle-dungeon',
                nameType: 3,
                overrideName: 'Dungeons',
                overrideSlug: 'dungeons',
            },
            {
                targetSlug: 'dungeons-raids/battle-raid',
                nameType: 3,
                overrideName: 'Raids',
                overrideSlug: 'raids',
            },
            null,
            { targetSlug: 'expansion-features/heart-of-azeroth', nameType: 2 },
            { targetSlug: 'expansion-features/island-expeditions', nameType: 2 },
            { targetSlug: 'expansion-features/visions-of-nzoth', nameType: 2 },
            { targetSlug: 'expansion-features/war-effort', nameType: 2 },
        ],
    },
    {
        slug: 'shadowlands',
        children: [
            { targetSlug: 'exploration/shadowlands', nameType: 1 },
            { targetSlug: 'quests/shadowlands', nameType: 1 },
            { targetSlug: 'reputation/shadowlands', nameType: 1 },
            null,
            {
                targetSlug: 'dungeons-raids/shadowlands-dungeon',
                nameType: 3,
                overrideName: 'Dungeons',
                overrideSlug: 'dungeons',
            },
            {
                targetSlug: 'dungeons-raids/shadowlands-raid',
                nameType: 3,
                overrideName: 'Raids',
                overrideSlug: 'raids',
            },
            null,
            { targetSlug: 'expansion-features/covenant-sanctums', nameType: 2 },
            { targetSlug: 'expansion-features/torghast', nameType: 2 },
        ],
    },
    {
        slug: 'dragonflight',
        children: [
            {
                targetSlug: 'exploration/dragon-isles',
                nameType: 1,
                achievementIds: [
                    16761, // Dragon Isles Explorer
                ],
            },
            { targetSlug: 'quests/dragonflight', nameType: 1 },
            { targetSlug: 'reputation/dragonflight', nameType: 1 },
            null,
            {
                targetSlug: 'dungeons-raids/dragonflight-dungeon',
                nameType: 3,
                overrideName: 'Dungeons',
                overrideSlug: 'dungeons',
                achievementIds: [
                    16294, // Dragonflight Dungeon Hero
                    16295, // Glory of the Dragonflight Hero
                ],
            },
            {
                targetSlug: 'dungeons-raids/dragonflight-raid',
                nameType: 3,
                overrideName: 'Raids',
                overrideSlug: 'raids',
                achievementIds: [
                    16355, // Glory of the Vault Raider
                    18251, // Glory of the Aberrus Raider
                    19349, // Glory of the Dream Raider
                ],
            },
            null,
            {
                targetSlug: 'pet-battles/battle',
                nameType: 1,
                onlyAchievementIds: true,
                achievementIds: [
                    16519, // Dragon Isles Safari
                    17879, // Zaralek Cavern Safari
                    19401, // Emerald Dream Safari
                    16464, // Battle on the Dragon Isles
                    17406, // Battle on the Dragon Isles II
                    17880, // Battle in Zaralek Cavern
                    17541, // Global Swarming (Forbidden Reach)
                    16399, // Lovin' Lubbins
                    18383, // Hey Nanny Nanny
                    18384, // Whelp, There It Is
                    // Family Battler of the Dragon Isles
                    16501, // Aquatic
                    16503, // Beast
                    16504, // Critter
                    16505, // Dragonkin
                    16506, // Elemental
                    16507, // Flying
                    16508, // Humanoid
                    16509, // Magic
                    16510, // Mechanical
                    16511, // Undead
                    16512,
                    // Family Battler of Zaralek Cavern
                    17881, // Aquatic
                    17882, // Beast
                    17883, // Critter
                    17890, // Dragonkin
                    17904, // Elemental
                    17905, // Flying
                    17915, // Humanoid
                    17916, // Magic
                    17917, // Mechanical
                    17918, // Undead
                    17934,
                ],
            },
            {
                targetSlug: 'expansion-features/skyriding',
                nameType: 2,
                onlyAchievementIds: true,
                achievementIds: [
                    // Meta
                    19478,
                    // Glyph Hunter
                    16575, 16576, 16577, 16578, 17411,
                    // Waking Shores
                    15915, 15916, 15917, 15927, 15928, 15929, 17195, 17196, 17197,
                    // Ohn'ahran Plains
                    15918, 15919, 15920, 15930, 15931, 15932, 17198, 17199, 17200,
                    // Azure Span
                    15921, 15922, 15923, 15933, 15934, 15935, 17201, 17202, 17203,
                    // Thaldraszus
                    15924, 15925, 15926, 15936, 15937, 15938, 17204, 17205, 17206,
                    // Completionist
                    15939, 15940, 15941, 17330, 17331, 17332,
                    // Forbidden Reach
                    17279, 17280, 17281, 17284, 17286, 17287, 17288, 17289, 17290,
                    // Forbidden Reach Completionist
                    17294, 17296, 17298,
                    // Zaralek Cavern
                    17483, 17484, 17485, 17486, 17487, 17488, 17489, 17490, 17491,
                    // Zaralek Cavern Completionist
                    17492, 17493, 17494,
                    // Zaralek Cavern Glyph Hunter
                    18150,
                    // Challenge
                    18790, 18791, 18792,
                    // Emerald Dream
                    19109, 19110, 19111, 19112, 19113, 19114, 19115, 19116, 19117,
                    // Emerald Dream Completionist
                    19127, 19128, 19129,
                    // Emerald Dream Glyph Hunter
                    19306,
                ],
            },
            {
                targetSlug: 'collections/dragon-isle-drake-cosmetics',
                nameType: 3,
                overrideName: 'Drake Cosmetics',
                overrideSlug: 'drake-cosmetics',
            },
        ],
    },
    {
        slug: 'war-within',
        children: [
            { targetSlug: 'exploration/war-within', nameType: 1 },
            { targetSlug: 'quests/war-within', nameType: 1 },
            { targetSlug: 'reputation/war-within', nameType: 1 },
            null,
            {
                targetSlug: 'delves/the-war-within',
                nameType: 1,
                achievementIds: [
                    40438, // Glory of the Delver
                    40537, // Delve Loremaster: War Within
                    40437, // Delver of the Depths 1
                    40447, // Delver of the Depths 2
                    40448, // Delver of the Depths 3
                    40449, // Delver of the Depths 4
                ],
            },
            {
                targetSlug: 'dungeons-raids/war-within-dungeon',
                nameType: 3,
                overrideName: 'Dungeons',
                overrideSlug: 'dungeons',
            },
            {
                targetSlug: 'dungeons-raids/war-within-raid',
                nameType: 3,
                overrideName: 'Raids',
                overrideSlug: 'raids',
                achievementIds: [
                    40232, // Glory of the Nerub-ar Raider
                    41286, // Glory of the Liberation of Undermine Raider
                    41597, // Glory of the Omega Raider
                ],
            },
            {
                targetSlug: 'player-vs-player/world',
                nameType: 1,
                onlyAchievementIds: true,
                achievementIds: [
                    40087, // Unbound Battle
                    40097, // Ruffious's Bid
                    40088, // A Champion's Tour: The War Within
                    40086, // Tour of Duty: Azj-Kahet
                    40085, // Tour of Duty: Hallowfall
                    40084, // Tour of Duty: The Ringing Deeps
                    40083, // Tour of Duty: Isle of Dorn
                    40089, // Spoiled Goods 1
                    40090, // Spoiled Goods 2
                    40091, // Slightly Spoiled
                    41522, // Tour of Duty: Undermine
                    42131, // Tour of Duty: K'aresh
                    40468, // Unbound Glory 1
                    40466, // Unbound Glory 2
                    40467, // Unbound Glory 3
                    40465, // Unbound Bounty
                ],
            },
            null,
            {
                targetSlug: 'pet-battles/battle',
                nameType: 1,
                onlyAchievementIds: true,
                achievementIds: [
                    40194, // Khaz Algar Safari
                    40153, // Battle on Khaz Algar
                    41092, // Undermine Safari
                    // Family Battler of Khaz Algar
                    40154,
                    40155,
                    40156,
                    40157,
                    40158,
                    40161,
                    40162,
                    40163,
                    40164,
                    40165,
                    40980,
                    // Family Battler of Undermine
                    41543,
                    41541,
                    41544,
                    41545,
                    41546,
                    41547,
                    41548,
                    41549,
                    41550,
                    41551,
                ],
            },
            {
                targetSlug: 'expansion-features/skyriding',
                nameType: 2,
                onlyAchievementIds: true,
                achievementIds: [
                    // Glyph Hunter
                    40702, 40166, 40703, 40704, 40705, 42727,
                    // Isle of Dorn
                    40316, 40317, 40318, 40139, 40320, 40321, 40322, 40323, 40324,
                    // Ringing Deeps
                    40325, 40326, 40327, 40328, 40329, 40330, 40331, 40332, 40333,
                    // Hallowfall
                    40334, 40335, 40336, 40337, 40338, 40339, 40340, 40341, 40342,
                    // Azj-Kahet
                    40343, 40344, 40345, 40346, 40347, 40348, 40349, 40350, 40351,
                    // Khaz Algar Completionist
                    40352, 40353, 40354,
                    // Undermine Skyrocketing
                    40936, 40937, 40938,
                    // Undermine Breaknecking
                    41081, 41083, 41084,
                ],
            },
            {
                targetSlug: 'expansion-features/visions-of-nzoth-revisited',
                nameType: 3,
                overrideName: 'Visions Revisited',
                overrideSlug: 'visions-revisited',
            },
        ],
    },
    {
        slug: 'midnight',
        children: [
            { targetSlug: 'exploration/midnight', nameType: 1 },
            { targetSlug: 'quests/midnight', nameType: 1 },
            { targetSlug: 'reputation/midnight', nameType: 1 },
            null,
            {
                targetSlug: 'delves/midnight',
                nameType: 1,
                achievementIds: [
                    63718, // Lock and Key
                    63719, // Lock and Key Master
                    63720, // Happy Hexmask Collector
                    63721, // The Labyrinth of Kindo'jan
                    63722, // Whose Labyrinth?
                    63723, // My Labyrinth
                    63724, // Knock Knock
                    63717, // Kindo'jan's Labyrinth Discoveries
                    63727, // Treasures Upon Treasures
                    63728, // A Few More Can't Hurt
                ],
            },
            {
                targetSlug: 'dungeons-raids/midnight-dungeon',
                nameType: 3,
                overrideName: 'Dungeons',
                overrideSlug: 'dungeons',
                achievementIds: [
                    61567, // Midnight Dungeon Hero
                    61568, // Glory of the Midnight Hero
                ],
            },
            {
                targetSlug: 'dungeons-raids/midnight-raid',
                nameType: 3,
                overrideName: 'Raids',
                overrideSlug: 'raids',
                achievementIds: [
                    61380, // Glory of the Midnight Raider
                    63254, // Glory of the Venomous Raider
                ],
            },
            {
                targetSlug: 'player-vs-player/world',
                nameType: 1,
                onlyAchievementIds: true,
                achievementIds: [
                    61446, // Slayer's Mastery
                    61464, // Spark in the Night
                    61465, // Spark in the Night
                    61447, // Partake in the Rise
                    61448, // Frequent the Rise
                    61449, // Customary Rise
                    61265, // Spectral Capture
                    61266, // Spectral Stocker
                    61234, // Hunt in the Night
                    61238, // Midnight Bounty
                    61231, // Midnight Loot
                    61232, // Midnight Treasures
                    61230, // Remains in the Rise
                    61227, // Entering the Void
                    61228, // Embracing the Void
                    61229, // Dedication in the Void
                    61225, // Investigating the Rise
                    61226, // Uprising
                    61221, // Tour of Duty: Eversong Woods
                    61222, // Tour of Duty: Zul'Aman
                    61223, // Tour of Duty: Harandar
                    61224, // Tour of Duty: Voidstorm
                    63167, // Tour of Duty: The Coiled Isle
                ],
            },
            null,
            { targetSlug: 'expansion-features/prey', nameType: 2 },
            { targetSlug: 'expansion-features/ritual-sites', nameType: 2 },
            { targetSlug: 'expansion-features/void-assaults', nameType: 2 },
        ],
    },
    {
        slug: 'prepatch-midnight',
        achievementIds: [
            42300, // Two Minutes to Midnight
            61430, // Crunching for Cultists
        ],
        children: [],
    },
    {
        slug: 'outland-cup',
        achievementIds: [
            19092, 19097, 19098, 19099, 19100, 19101, 19102, 19103, 19104, 19105, 19106, 19107,
        ],
        children: [],
    },
    {
        slug: 'northrend-cup',
        achievementIds: [
            19674, 19675, 19676, 19677, 19679, 19681, 19682, 19683, 19684, 19721, 19722, 19723,
        ],
        children: [],
    },
];
